const isNear = (a, b) => a?.lat != null && a?.lng != null && b?.lat != null && b?.lng != null
  && Math.abs(a.lat - b.lat) < 0.01 && Math.abs(a.lng - b.lng) < 0.01;

const isSameStop = (stop, orderedStop) => Boolean(stop) && (
  (stop.lat === orderedStop.lat && stop.lng === orderedStop.lng)
  || (stop.name && stop.name === orderedStop.name)
  || isNear(stop, orderedStop)
);

/**
 * Index of the planner stop that a routed stop came from.
 *
 * Position is checked first: on a round trip the start and end are the same
 * place, so matching on name or coordinates alone sends the end stop's places
 * to the start stop. Blank placeholder rows never reach the route, so they are
 * skipped when counting positions.
 */
export const findMatchingStopIndex = (dayStops = [], orderedStop, orderedIndex) => {
  if (!orderedStop) return -1;

  const routedIndices = dayStops
    .map((stop, index) => (stop?.name || stop?.lat != null ? index : -1))
    .filter((index) => index !== -1);
  const positional = routedIndices[orderedIndex];
  if (positional != null && isSameStop(dayStops[positional], orderedStop)) return positional;

  let index = dayStops.findIndex((s) => s.lat === orderedStop.lat && s.lng === orderedStop.lng);
  if (index === -1) index = dayStops.findIndex((s) => s.name && s.name === orderedStop.name);
  if (index === -1) index = dayStops.findIndex((s) => isNear(s, orderedStop));
  return index;
};

export const findMatchingStop = (dayStops = [], orderedStop, orderedIndex) => {
  const index = findMatchingStopIndex(dayStops, orderedStop, orderedIndex);
  return index === -1 ? undefined : dayStops[index];
};

/**
 * Every place picked for a day, grouped under the stop it belongs to, for the
 * "your stops" panel. Blank placeholder rows are left out.
 */
export const getStopsWithPlaces = (dayStops = []) => dayStops
  .filter((stop) => stop?.name || stop?.address)
  .map((stop) => ({
    id: stop.id,
    name: stop.name || stop.address,
    places: stop.savedPois || [],
  }));
